import React, { useState, useEffect } from 'react';
import { getRol } from '../../../_utils/storage_handler';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Checkbox from '@mui/material/Checkbox';
import { findRemissionEvent,remissionPDFEvent} from '../../../_events/remission/find_remission.event';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import RemissionList from './remission_list';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import { isNotViewer } from '../../../_utils/render_actions';
import { downloadExcelFile } from '../../../_utils/download_file.util';
import { processRemissionEvent } from '../../../_events/orderDetail/orderDetail.event';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};

const RemissionBox = () => {
  const [allChecked, setAllChecked] = useState(false);
  const [remission, setRemission] = useState([]);
  const [remissions, setRemissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [pdf, setPDF] = React.useState(null);
  const [excel, setExcel] = React.useState(null);
  const [selectedRemissions, setSelectedRemissions] = useState([]); 

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClosePDF = () => {
    setOpenPDF(false);
    setPDF(null);
  };

  const loadRemissions = () => {
    setAllChecked(false);
    setLoading(true);
    findRemissionEvent()
    .then(data => {
      setRemissions(data.list);
      setLoading(false);
    })
    .catch(err => {
      message.error(err.message);
      setLoading(false);
    });
  };

  const setEditRemission = (remission) => {
    setRemission(remission);
    handleOpen();
  };

  const approve = () => {
    if (selectedRemissions.length <= 0) {
      message.warning('No tiene remisiones seleccionadas');
    }
    if (selectedRemissions.length > 0) {
    processRemissionEvent(selectedRemissions)
    .then(data => {
      loadRemissions();
      setExcel(data.data);
      downloadExcelFile(data.data,"Excel_facturacion");
      message.success('Remisiones procesadas');
    })
    .catch(err => {
      message.error(err.message);
      setLoading(false);
    });
    }
  };

  const displayPDF = (remission) =>{
    setOpenPDF(true);
    remissionPDFEvent(remission.uuid)
      .then(data => {
        setPDF(data.data);
      })
      .catch(err => {
        message.error(err.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadRemissions();
  }, []);

  let rol = getRol();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <Typography variant="h6" component="h6">
          Bandeja de Remisiones
        </Typography>
        <hr />
        {loading ? (
          <PrimaryProgress />
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={6} md={6}>
              <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                <Chip label={`Total: ${remissions.length}`} color="primary" variant="outlined" />
                <Chip label={`Entregas INMEDIATAS: `} color="error" variant="outlined" />
                <Chip label={`Seleccionadas: ${selectedRemissions.length}`} color="success" variant="outlined" />
              </div>
            </Grid>
            <Grid item xs={6} md={6}>
              <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '100%' }}>
                <BasicPopconfirm
                  label="Aprobar remisiones"
                  title="¿Seguro/a que deseas aprobar todas las remisiones seleccionadas?" // Actualiza el mensaje
                  onConfirm={() => {
                    isNotViewer(rol) ? approve() : alert('Usuario informativo');
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={12}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
               
              </div>
            </Grid>
            <Grid item xs={12} md={12}>
              <RemissionList
                data={remissions}
                setEditRemission={remission => setEditRemission(remission)}
                updateDataOrdersChecked={r => {
                  let remissionUUID = r.uuid;
                  if (selectedRemissions.includes(remissionUUID)) {
                    setSelectedRemissions(selectedRemissions.filter(uuid => uuid !== remissionUUID));
                  } else {
                    setSelectedRemissions([...selectedRemissions, remissionUUID]);
                  }
                }}
                displayPDF={r => displayPDF(r)}
                selectedRemissions={selectedRemissions}
              />
            </Grid>
          </Grid>
        )}
      </Grid>


      <Modal
            open={openPDF}
            onClose={handleClosePDF}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
        <Box sx={style}>
          <Grid container spacing={1}>
            {
              !pdf ? <>Cargando...</> :
              <Grid item xs={12} md={12}>
                <object width="100%" height="600px" 
                  data={`data:application/pdf;base64,${pdf}`} 
                  type="application/pdf" className="internal"
                >
                  <embed 
                      src={`data:application/pdf;base64,${pdf}`}
                      type="application/pdf"
                  />
                </object>
              </Grid>
            }
          </Grid>
        </Box>
      </Modal>

    </Grid>
  );
};

export default RemissionBox;
